angular.module('bmsApp.taxHelper', [])
	.service('TaxHelperSvc', function (CRUDSvc, $q) {

		var vatRate = undefined;

		function setVatRate() {
			var deferred = $q.defer();

			if (angular.isDefined(vatRate)) {
				deferred.resolve(vatRate);
			}
			else {
				CRUDSvc.get('api/accounting/current-vat-rate')
					.then(function (response) {
						vatRate = parseFloat(response.data.vat_rate);
						deferred.resolve(vatRate);
					});
			}

			return deferred.promise;
		}

		function getVatRate() {
			var deferred = $q.defer();

			if (angular.isDefined(vatRate)) {
				deferred.resolve(vatRate);
			}
			else {
				setVatRate()
					.then(function (newVatRate) {
						deferred.resolve(newVatRate);
					});
			}

			return deferred.promise;
		}

		function getRawVatRate() {
			return vatRate;
		}

		function roundDecimals(number, dp) {
			if (angular.isUndefined(dp)) {
				dp = 2;
			}
			return Math.round(number * Math.pow(10, dp)) / Math.pow(10, dp);
		}

		function vatFromNet(net, vatRateApplied) {
			if (!angular.isUndefined(vatRateApplied)) {
				vatRate = vatRateApplied;
			} else if (angular.isUndefined(vatRate)) {
				throw "VAT Rate not set, call TaxHelperSvc.setVatRate()";
			}

			return roundDecimals(parseFloat(net) * vatRate / 100);
		}

		function grossFromNet(net, vatRateApplied) {
			return roundDecimals(parseFloat(net) + vatFromNet(net, vatRateApplied));
		}

		function netFromGross(gross) {
			if (angular.isUndefined(vatRate)) {
				throw "VAT Rate not set, call TaxHelperSvc.setVatRate()";
			}

			return roundDecimals(100 / (100 + vatRate) * parseFloat(gross));
		}

		function vatFromGross(gross) {
			return roundDecimals(parseFloat(gross) - netFromGross(gross));
		}

		return {
			setVatRate: setVatRate,
			getVatRate: getVatRate,
			getRawVatRate: getRawVatRate,
			vatFromNet: vatFromNet,
			grossFromNet: grossFromNet,
			netFromGross: netFromGross,
			vatFromGross: vatFromGross,
			roundDecimals: roundDecimals
		}

	});
